(function () {
  var UC = '/apps/b2b-checkout/tanidik';
  var NITELIK_BEKLEME = 700;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function init() {
    var kok = document.getElementById('adell-dost-main');
    if (!kok || kok.dataset.bound === '1') return;
    var bolum = kok.closest('.shopify-section') || document;
    var form = bolum.querySelector('form[is="cart-discount"]');
    if (!form) return;
    kok.dataset.bound = '1';

    var kodEl = form.querySelector('input[name="discount"]');
    var gonder = form.querySelector('[type="submit"]');
    var mesaj = kok.querySelector('[data-dost-mesaj]');
    var sonuc = kok.querySelector('[data-dost-sonuc]');
    var tablo = kok.querySelector('[data-dost-tablo]');
    var toplamEl = kok.querySelector('[data-dost-toplam]');
    var listeEl = kok.querySelector('[data-dost-liste]');
    var indirimEl = kok.querySelector('[data-dost-indirim]');
    var ode = kok.querySelector('[data-dost-ode]');
    if (!kodEl || !ode) return;

    form.insertAdjacentElement('afterend', kok);

    var m = kok.dataset;
    var sonKod = '';
    var sayi = new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var fmt = { format: function (n) { return sayi.format(n) + ' TL'; } };

    function goster(metin, tur) {
      mesaj.textContent = metin || '';
      mesaj.hidden = !metin;
      mesaj.dataset.tur = tur || 'hata';
      kok.hidden = mesaj.hidden && sonuc.hidden;
    }

    function sonucGoster(acik) {
      sonuc.hidden = !acik;
      kok.hidden = mesaj.hidden && sonuc.hidden;
    }

    function salla(el) {
      if (!el) return;
      el.classList.add('adell-consent--shake');
      setTimeout(function () { el.classList.remove('adell-consent--shake'); }, 600);
      if (el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function yukleniyor(acik) {
      if (!gonder) return;
      gonder.classList.toggle('btn--loading', acik);
      if (acik) gonder.setAttribute('aria-disabled', 'true');
      else gonder.removeAttribute('aria-disabled');
    }

    function sepet() {
      return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    }

    function istek(mod) {
      return sepet().then(function (cart) {
        if (!cart.items || !cart.items.length) return { ok: false, j: { error: m.msgBos, kod: 'bos' } };
        return fetch(UC, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            kod: sonKod,
            mod: mod,
            lines: cart.items.map(function (i) { return { variantId: i.variant_id, quantity: i.quantity }; }),
            attributes: cart.attributes || {}
          })
        }).then(function (r) {
          return r.json().then(function (j) { return { ok: r.ok, j: j }; });
        });
      });
    }

    function temaAkisi(event) {
      if (typeof form.handleFormSubmit === 'function') form.handleFormSubmit(event);
    }

    function onizle(event) {
      sonKod = (kodEl.value || '').trim().toUpperCase();
      if (!sonKod) return;
      if (m.giris !== '1') {
        goster(m.msgUyeNotu, 'not');
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      sonucGoster(false);
      goster('');
      yukleniyor(true);
      istek('onizle').then(function (r) {
        yukleniyor(false);
        if (r.j && r.j.kod === 'gecersiz') {
          temaAkisi(event);
          return;
        }
        if (!r.ok || !r.j || !r.j.ok) { goster((r.j && r.j.error) || m.msgHata); return; }
        tablo.innerHTML = r.j.satirlar.map(function (s) {
          var liste = s.price * s.quantity;
          var hedef = s.hedef * s.quantity;
          var pct = liste > 0 ? Math.round((1 - hedef / liste) * 100) : 0;
          var meta = [s.variantTitle, s.quantity + ' ' + m.msgAdet].filter(Boolean).join(' · ');
          return '<li class="adell-dost__item">'
            + '<div class="adell-dost__img">' + (s.image ? '<img src="' + esc(s.image) + '" alt="" loading="lazy">' : '') + '</div>'
            + '<div><div class="adell-dost__name">' + esc(s.title) + '</div><div class="adell-dost__meta">' + esc(meta) + '</div></div>'
            + '<div class="adell-dost__price">'
            + (hedef < liste ? '<span class="adell-dost__was">' + fmt.format(liste) + '</span>' : '')
            + '<span class="adell-dost__now">' + fmt.format(hedef) + '</span>'
            + (pct > 0 ? '<span class="adell-dost__pct">%' + pct + '</span>' : '')
            + '</div></li>';
        }).join('');
        listeEl.textContent = fmt.format(r.j.listeToplam);
        indirimEl.textContent = '−' + fmt.format(r.j.indirimToplam);
        toplamEl.textContent = fmt.format(r.j.toplam);
        goster(m.msgUygulandi, 'ok');
        sonucGoster(true);
        ode.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }).catch(function () {
        yukleniyor(false);
        goster(m.msgHata);
      });
    }

    function onKontrol() {
      var wrap = document.getElementById('adell-consent-main');
      var cbs = wrap ? Array.prototype.slice.call(wrap.querySelectorAll('.adell-consent__cb')) : [];
      if (cbs.length && !cbs.every(function (c) { return c.checked; })) {
        salla(wrap);
        return m.msgOnay;
      }
      var vkn = document.getElementById('AdellVknMain');
      var vknHata = vkn && typeof vkn.dogrula === 'function' ? vkn.dogrula() : '';
      if (vknHata) { salla(vkn); return vknHata; }
      var tes = document.getElementById('AdellTeslimatMain');
      var tesHata = tes && typeof tes.dogrula === 'function' ? tes.dogrula() : '';
      if (tesHata) {
        if (typeof tes.hataGoster === 'function') tes.hataGoster(tesHata);
        salla(tes);
        return tesHata;
      }
      return '';
    }

    function odemeyeGec() {
      var hata = onKontrol();
      if (hata) { goster(hata); return; }
      ode.disabled = true;
      goster(m.msgYonlendir, 'ok');
      setTimeout(function () {
        istek('odeme').then(function (r) {
          if (!r.ok || !r.j || !r.j.ok || !r.j.invoiceUrl) {
            ode.disabled = false;
            goster((r.j && r.j.error) || m.msgHata);
            return;
          }
          return fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' })
            .catch(function () {})
            .then(function () { window.location.href = r.j.invoiceUrl; });
        }).catch(function () {
          ode.disabled = false;
          goster(m.msgHata);
        });
      }, NITELIK_BEKLEME);
    }

    document.addEventListener('submit', function (event) {
      if (event.target === form) onizle(event);
    }, true);
    ode.addEventListener('click', odemeyeGec);

    document.addEventListener('cart:updated', function () {
      if (!sonuc.hidden) { sonucGoster(false); goster(''); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('cart:updated', init);
})();
